// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3dkyy","left":"InfoRow_left__1FkGe"};